import React, { useState, useEffect } from 'react';

const Settings = () => {
  // États pour chaque section
  const [notificationsEnabled, setNotificationsEnabled] = useState(false);
  const [theme, setTheme] = useState('Clair');
  const [language, setLanguage] = useState('Français');
  const [email, setEmail] = useState('utilisateur@example.com');
  const [username, setUsername] = useState('Utilisateur1');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [marketingEmails, setMarketingEmails] = useState(true);
  const [profileVisibility, setProfileVisibility] = useState('public');
  const [subscriptionPlan, setSubscriptionPlan] = useState('Gratuit');
  const [activityHistory, setActivityHistory] = useState(true);

  // Charger les préférences sauvegardées (exemple avec localStorage)
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) setTheme(savedTheme);
  }, []);

  // Gestionnaires d'événements
  const handleThemeChange = (e) => {
    setTheme(e.target.value);
    localStorage.setItem('theme', e.target.value);
  };

  const handlePasswordChange = (e) => {
    e.preventDefault();
    if (newPassword === confirmPassword) {
      alert('Mot de passe changé avec succès !');
    } else {
      alert('Les mots de passe ne correspondent pas.');
    }
  };

  const handleUpdateAccount = (e) => {
    e.preventDefault();
    alert('Informations du compte mises à jour !');
  };

  const handleDeleteAccount = () => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.')) {
      alert('Votre compte a été supprimé.');
    }
  };

  return (
    <div className="settings-container">
      <h1>Paramètres du compte</h1>

      {/* Section Préférences Utilisateur */}
      <div className="settings-section">
        <h2>Préférences Utilisateur</h2>
        <form>
          <label>
            <input
              type="checkbox"
              checked={notificationsEnabled}
              onChange={(e) => setNotificationsEnabled(e.target.checked)}
            />
            Activer les notifications
          </label>
          <label>
            Thème :
            <select value={theme} onChange={handleThemeChange}>
              <option>Clair</option>
              <option>Sombre</option>
              <option>Système</option>
            </select>
          </label>
          <label>
            Langue :
            <select value={language} onChange={(e) => setLanguage(e.target.value)}>
              <option>Français</option>
              <option>Anglais</option>
              <option>Espagnol</option>
              <option>Allemand</option>
            </select>
          </label>
        </form>
      </div>

      {/* Section Notifications */}
      <div className="settings-section">
        <h2>Notifications</h2>
        <form>
          <label>
            <input
              type="checkbox"
              checked={marketingEmails}
              onChange={(e) => setMarketingEmails(e.target.checked)}
            />
            Recevoir des emails marketing
          </label>
          <label>
            <input type="checkbox" />
            Notifications par SMS
          </label>
          <label>
            <input type="checkbox" />
            Notifications push
          </label>
        </form>
      </div>

      {/* Section Sécurité */}
      <div className="settings-section">
        <h2>Sécurité</h2>
        <form onSubmit={handlePasswordChange}>
          <label>
            Mot de passe actuel :
            <input
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
            />
          </label>
          <label>
            Nouveau mot de passe :
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </label>
          <label>
            Confirmer le nouveau mot de passe :
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </label>
          <button type="submit">Changer le mot de passe</button>
        </form>
      </div>

      {/* Section Compte */}
      <div className="settings-section">
        <h2>Compte</h2>
        <form onSubmit={handleUpdateAccount}>
          <label>
            Email :
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          <label>
            Nom d'utilisateur :
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </label>
          <button type="submit">Mettre à jour les informations</button>
        </form>
      </div>

      {/* Section Confidentialité */}
      <div className="settings-section">
        <h2>Confidentialité</h2>
        <form>
          <label>
            Visibilité du profil :
            <select value={profileVisibility} onChange={(e) => setProfileVisibility(e.target.value)}>
              <option value="public">Public</option>
              <option value="friends">Amis uniquement</option>
              <option value="private">Privé</option>
            </select>
          </label>
          <label>
            <input
              type="checkbox"
              checked={activityHistory}
              onChange={(e) => setActivityHistory(e.target.checked)}
            />
            Enregistrer l'historique d'activité
          </label>
          <label>
            <input type="checkbox" />
            Autoriser les recherches par email
          </label>
        </form>
      </div>

      <div className="settings-section">
          <h2>Abonnement</h2>
          <p>Votre abonnement actuel : <strong>{subscriptionPlan}</strong></p>
          <label>
            Changer de plan :
            <select
              value={subscriptionPlan}
              onChange={(e) => setSubscriptionPlan(e.target.value)}
            >
              <option>Gratuit</option>
              <option>Premium</option>
              <option>Entreprise</option>
            </select>
          </label>
          <button type="button">Mettre à niveau</button>
          <button type="button">Gérer le paiement</button>
        </div>


      {/* Section Historique d'activité */}
      <div className="settings-section">
        <h2>Historique d'activité</h2>
        <p>Vos dernières connexions :</p>
        <ul>
          <li>Connexion depuis Paris, France (il y a 2 jours)</li>
          <li>Connexion depuis Toulouse, France (il y a 1 semaine)</li>
        </ul>
        <button type="button">Télécharger mes données</button>
      </div>

      {/* Section Suppression de compte */}
      <div className="settings-section">
        <h2>Suppression de compte</h2>
        <p>La suppression de votre compte est irréversible.</p>
        <button type="button" onClick={handleDeleteAccount} className="delete-account">
          Supprimer mon compte
        </button>
      </div>

      {/* Bouton de sauvegarde global */}
      <div className="settings-footer">
        <button onClick={() => alert('Tous les paramètres ont été sauvegardés !')}>
          Sauvegarder tous les paramètres
        </button>
      </div>
    </div>
  );
};

export default Settings;
